// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-sparrow-mobile] .fade-enter,[data-sparrow-mobile] .fade-leave-to{transition-delay:1s}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
